var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientsSearchIconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.184 13.188L14.3174 14.3181M13.7761 11.7608C13.7807 11.4933 13.7318 11.2275 13.6326 10.979C13.5333 10.7305 13.3855 10.5042 13.1979 10.3134C13.0103 10.1226 12.7866 9.9711 12.5398 9.86766C12.293 9.76421 12.0281 9.71094 11.7605 9.71094C11.4929 9.71094 11.228 9.76421 10.9812 9.86766C10.7344 9.9711 10.5107 10.1226 10.3231 10.3134C10.1354 10.5042 9.98768 10.7305 9.88841 10.979C9.78913 11.2275 9.74033 11.4933 9.74483 11.7608C9.75373 12.2895 9.97001 12.7936 10.3471 13.1643C10.7241 13.5351 11.2317 13.7428 11.7605 13.7428C12.2893 13.7428 12.7969 13.5351 13.1739 13.1643C13.551 12.7936 13.7672 12.2895 13.7761 11.7608Z",
    stroke: "#6860EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40452 13.7566H8.43121M13.8282 8.50182C13.8282 7.76367 13.6344 7.35312 12.9701 7.07663C12.3253 6.80821 10.9707 6.48321 10.3959 6.29492",
    stroke: "#6860EE",
    strokeWidth: 1.00156,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03529 13.3101L2.03529 4.41261C2.03529 2.87787 2.03529 2.10988 2.54313 1.72894C3.05098 1.34801 3.79893 1.55529 5.2955 1.96863L8.50566 2.85585C9.40831 3.10533 9.85969 3.23007 10.1203 3.57064C10.3817 3.91061 10.3817 4.37348 10.3817 5.30045V7.9205",
    stroke: "#6860EE",
    strokeWidth: 0.96304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24584 5.80957H7.17192M5.24584 8.25535H7.17192M7.81395 13.6809V11.9242C7.81395 11.3475 7.81395 11.0595 7.62583 10.8803C7.43772 10.7012 7.13532 10.7012 6.52989 10.7012H5.88787C5.28243 10.7012 4.98005 10.7012 4.79193 10.8803C4.60382 11.0595 4.60382 11.3475 4.60382 11.9242V13.6997",
    stroke: "#6860EE",
    strokeWidth: 0.96304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsSearchIconLight);
export default __webpack_public_path__ + "static/media/Clients Search Icon Light.04e2b6100bc536b9da91137a02a0ee04.svg";
export { ForwardRef as ReactComponent };